module.exports = __webpack_public_path__ + "static/colgadas-012-53088f03ff688835441ac0f2677a9a2d.jpg";